/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scan_Image_Or_PdfInputs */

const en_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Image or PDF`)
};

const es_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escanear imagen o PDF`)
};

const fr_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanner Image ou PDF`)
};

const de_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild oder PDF scannen`)
};

const ja_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像またはPDFをスキャン`)
};

const zh_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扫描图片或 PDF`)
};

const ar_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسح صورة أو PDF`)
};

const id_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pindai Gambar atau PDF`)
};

const it_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scansiona Immagine o PDF`)
};

const ru_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сканировать Изображение или PDF`)
};

const pt_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escanear Imagem ou PDF`)
};

const ko_scan_image_or_pdf = /** @type {(inputs: Scan_Image_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미지 또는 PDF 스캔`)
};

/**
* | output |
* | --- |
* | "Scan Image or PDF" |
*
* @param {Scan_Image_Or_PdfInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const scan_image_or_pdf = /** @type {((inputs?: Scan_Image_Or_PdfInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scan_Image_Or_PdfInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scan_image_or_pdf(inputs)
	if (locale === "es") return es_scan_image_or_pdf(inputs)
	if (locale === "fr") return fr_scan_image_or_pdf(inputs)
	if (locale === "de") return de_scan_image_or_pdf(inputs)
	if (locale === "ja") return ja_scan_image_or_pdf(inputs)
	if (locale === "zh") return zh_scan_image_or_pdf(inputs)
	if (locale === "ar") return ar_scan_image_or_pdf(inputs)
	if (locale === "id") return id_scan_image_or_pdf(inputs)
	if (locale === "it") return it_scan_image_or_pdf(inputs)
	if (locale === "ru") return ru_scan_image_or_pdf(inputs)
	if (locale === "pt") return pt_scan_image_or_pdf(inputs)
	return ko_scan_image_or_pdf(inputs)
});